import * as React from 'react';
import { SkeletonLoader } from '@grandvisionhq/elements';
import { useIntl } from '@grandvisionhq/state';

const SubscriptionLineItemLoader = ()=>{
    const { getLabel  } = useIntl();
    return /*#__PURE__*/ React.createElement(SkeletonLoader, {
        "data-t": "subscription-line-loader"
    }, /*#__PURE__*/ React.createElement("svg", {
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-label": getLabel('common.loadingText')
    }, /*#__PURE__*/ React.createElement("rect", {
        width: "30%",
        height: "100%",
        rx: "5",
        fill: "currentColor"
    }), /*#__PURE__*/ React.createElement("rect", {
        width: "40%",
        height: "15px",
        rx: "5",
        fill: "currentColor",
        x: "35%"
    }), /*#__PURE__*/ React.createElement("rect", {
        width: "40%",
        height: "15px",
        rx: "5",
        fill: "currentColor",
        x: "35%",
        y: "30"
    }), /*#__PURE__*/ React.createElement("rect", {
        width: "25%",
        height: "15px",
        rx: "5",
        fill: "currentColor",
        x: "35%",
        y: "60"
    })));
};
var SubscriptionLineItemLoader$1 = SubscriptionLineItemLoader;

export { SubscriptionLineItemLoader$1 as default };
//# sourceMappingURL=SubscriptionLineItemLoader.js.map
